<template>
    <div class="Hexagon relative inline-block">
        <div style="color: #3f67f2; font-size: 25px; display: flex; align-items: center; justify-content: center;">&#x2B22;</div>
        <div style="font-weight: 500; color: #fff; position: absolute; top: 0; left: 0; right: 0; z-index: 1; font-size: 9px; display: flex; align-items: center; justify-content: center; height: 100%;">
            {{ rank ? rank : 0 }}
        </div>
    </div>
</template>
<script>
export default {
    name: 'Hexagon',
    props: ['rank']
}
</script>
<style lang="scss" scoped>
.Hexagon{
    display: flex;
    justify-content: center;
}
</style>
